import TeniloBanner from './tenilo-banner-view'
export default TeniloBanner
